import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ roles, children, redirectTo = "/login" }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-mute" data-testid="auth-loading">
        Loading SyncLine…
      </div>
    );
  }
  if (!user) return <Navigate to={redirectTo} state={{ from: loc.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "pm" ? "/pm" : "/panel";
    return <Navigate to={home} replace />;
  }
  return children;
}
